import Lottie from 'react-lottie-player';

import { Box, Link, Stack } from '@mui/material';

import { styled } from '@/theme/styled';
import { getBorder } from '@/theme/utils';

const Section = styled(Link)(({ theme }) => ({
  padding: theme.spacing(1.5, 2),
  height: 116,
  width: 193,
  flexShrink: 0,
  cursor: 'pointer',
  borderRadius: theme.shape.borderRadius,
  border: getBorder(theme.palette.border.default),
  color: theme.palette.text.default,
  textDecoration: 'none',
  position: 'relative',
  overflow: 'hidden',
  '&:hover': {
    textDecoration: 'none',
    boxShadow: theme.shadows[2],
  },
}));

const List = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  overflow: 'auto',
  alignItems: 'center',
  gap: theme.spacing(3),
  padding: theme.spacing(4),
  margin: theme.spacing(0, -4, -4, -4),
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
}));

const AnimationBg = styled(Lottie)({
  position: 'absolute',
  inset: 0,
  width: '100%',
  height: '100%',
  zIndex: 0,
  pointerEvents: 'none',
});

AnimationBg.defaultProps = {
  loop: true,
  play: false,
  speed: 1,
  style: { width: '100%', height: '100%' },
};

const StaticSvgContainer = styled(Box)({
  width: '100%',
  height: '100%',
  position: 'absolute',
  // this imperfection between the static svg and the animation
  scale: 0.97,
  left: -1.5,
  top: -1.5,
});

export { Section, List, AnimationBg, StaticSvgContainer };
